import React from 'react';
import PropTypes from 'prop-types';

const IosArrowLeft = ({ color = '#C70000', width = 7, height = 14 }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="group">
<path id="Vector" d="M12.7 10C12.7 10.99 11.89 11.8 10.9 11.8H1V4.6C1 2.611 2.611 1 4.6 1H12.7V10Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M19 14.5C19 15.994 17.794 17.2 16.3 17.2H15.4C15.4 16.21 14.59 15.4 13.6 15.4C12.61 15.4 11.8 16.21 11.8 17.2H8.2C8.2 16.21 7.39 15.4 6.4 15.4C5.41 15.4 4.6 16.21 4.6 17.2H3.7C2.206 17.2 1 15.994 1 14.5V11.8H10.9C11.89 11.8 12.7 10.99 12.7 10V3.70001H14.356C15.004 3.70001 15.598 4.05102 15.922 4.60902L17.461 7.30001H16.3C15.805 7.30001 15.4 7.70501 15.4 8.20001V10.9C15.4 11.395 15.805 11.8 16.3 11.8H19V14.5Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_3" fill-rule="evenodd" clip-rule="evenodd" d="M6.4 19C5.40589 19 4.6 18.1941 4.6 17.2C4.6 16.2059 5.40589 15.4 6.4 15.4C7.39411 15.4 8.2 16.2059 8.2 17.2C8.2 18.1941 7.39411 19 6.4 19Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_4" fill-rule="evenodd" clip-rule="evenodd" d="M13.6 19C12.6059 19 11.8 18.1941 11.8 17.2C11.8 16.2059 12.6059 15.4 13.6 15.4C14.5941 15.4 15.4 16.2059 15.4 17.2C15.4 18.1941 14.5941 19 13.6 19Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_5" d="M19 11.8H16.3C15.805 11.8 15.4 11.395 15.4 10.9V8.19999C15.4 7.70499 15.805 7.29999 16.3 7.29999H17.461L19 9.99999V11.8Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>

);

IosArrowLeft.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default IosArrowLeft; 